import React from "react"
import useExternalFeatureFlag, {
  type UseExternalFeatureFlagParams
} from "contexts/ExternalFeatureFlag/useExternalFeatureFlag"
import ExternalFeatureFlagContext from "contexts/ExternalFeatureFlag"

export type { UseExternalFeatureFlagParams } from "contexts/ExternalFeatureFlag/useExternalFeatureFlag"

interface FeatureFlagProviderProps extends UseExternalFeatureFlagParams {
  children: React.ReactNode
}

const ExternalFeatureFlagProvider = ({
  children
}: FeatureFlagProviderProps) => {
  const value = useExternalFeatureFlag()

  return (
    <ExternalFeatureFlagContext.Provider value={value}>
      {children}
    </ExternalFeatureFlagContext.Provider>
  )
}

export default ExternalFeatureFlagProvider
